/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Last_VerifiedInputs */

const en_directory_detail_last_verified = /** @type {(inputs: Directory_Detail_Last_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last verified`)
};

const zh_directory_detail_last_verified = /** @type {(inputs: Directory_Detail_Last_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最近核验`)
};

/**
* | output |
* | --- |
* | "Last verified" |
*
* @param {Directory_Detail_Last_VerifiedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_last_verified = /** @type {((inputs?: Directory_Detail_Last_VerifiedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Last_VerifiedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_last_verified(inputs)
	return zh_directory_detail_last_verified(inputs)
});
export { directory_detail_last_verified as "directory.detail.last_verified" }